import { jsx } from 'react/jsx-runtime';
import { Paragraph } from '../pararaph/pararaph.esm.js';

const Description = ({ children, className })=>jsx(Paragraph, {
        small: true,
        children: children,
        className: className
    });

export { Description };
